import { useMediaQuery } from "react-responsive"

export const useDesktop = () => {
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 992px)',
  });

  return isDesktopOrLaptop;
}